import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import LoginScreen from "./app/screens/login_screen.js";
import LandingScreen from "./app/screens/landing_screen.js";
import { useEffect, useState } from "react";
import DashboardScreen from "./app/screens/dashboard_screen.js";
import StationInfoScreen from "./app/screens/station_info_screen.js";
import ConvertScreen from "./app/screens/convert_screen.js";
import AuthService from "./app/services/user_service.js";
import AdminScreen from "./app/screens/admin_screen.js";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.setItem("inputsPath", "/var/www/html/design_automation_files");
    // localStorage.setItem("inputsPath", "D:/BHEPL/iLock - Design Automation Works/Design Automation FIles Github/SER");

    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      setIsLoggedIn(false);
      setLoading(false);
      return;
    }

    AuthService.verify(user.id)
      .then(res => {
        if (res.data.valid) {
          setIsLoggedIn(true);
        } else {
          localStorage.clear();
          setIsLoggedIn(false);
        }
      })
      .catch(() => {
        localStorage.clear();
        setIsLoggedIn(false);
      })
      .finally(() => setLoading(false));

  }, []);

  if (loading) {
    return <div className="text-center mt-5">Checking session...</div>;
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isLoggedIn ? <DashboardScreen /> : <LandingScreen />} />
          <Route path="/login" element={isLoggedIn ? <Navigate to="/" replace /> : <LoginScreen />} />
          <Route path="/convert" element={<Navigate to="/" replace />} />
          <Route path="/station-info" element={<StationInfoScreen />} />
          <Route path="/admin" element={isLoggedIn && JSON.parse(localStorage.getItem("user") || "{}").role === 0 ? <AdminScreen /> : <Navigate to="/" replace />} />
        </Routes>
        <ToastContainer
          autoClose={2500}
        />
      </BrowserRouter>
    </>
  );
}

export default App;